module.exports = require("mux.js/lib/utils/clock");